import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';


const ADD_CATEGORY_API_URL =
  '/api/v1/quiz/builder/categorie-question/addcategorie-question';
const GET_CATEGORY_API_URL =
  '/api/v1/quiz/builder/categorie-question/getcategorie-questions?pagination=false';
const DELETE_CATEGORY_API_URL =
  '/api/v1/quiz/builder/categorie-question/deletecategorie-question/';

const UPDATE_CATEGORY_API_URL =
  '/api/v1/quiz/builder/categorie-question/updatecategorie-question/';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class CategoryQuestionService {
  constructor(private http: HttpClient, private auth: AuthenticationService) {}

  addQuestionCategory(newData: any): Observable<any> {
    return this.http.post<any>(`${BASE_URL}${ADD_CATEGORY_API_URL}`, newData);
  }

  getAllQuestionCategories(): Observable<any> {
    return this.http.get<any>(`${BASE_URL}${GET_CATEGORY_API_URL}`).pipe(
      map((categories) => {
        console.log('les categories disponibles', categories);
        return categories;
      })
    );
  }

  deleteQuestionCategory(id: number,uuid:string): Observable<any> {
    return this.http.delete<any>(`${BASE_URL}${DELETE_CATEGORY_API_URL}${id}/${uuid}`);
  }

  updateQuestionCategory(id: number,uuid:string, updatedData: any): Observable<any> {
    return this.http.put<any>(
      `${BASE_URL}${UPDATE_CATEGORY_API_URL}${id}/${uuid}`,
      updatedData
    );
  }
  //  updateQuestionCategory(id: number, updatedData: any): Observable<any> {
  //   return this.http.put<any>(
  //     `${BASE_URL}${UPDATE_CATEGORY_API_URL}${id}`,
  //     updatedData
  //   );
  // }
}
